<template>
    <div>
        <div>
            <div class="sub_title marginT15">
                서비스 이용약관
            </div>
            <div class="sub_content_wrap">
                <el-input id="cs_stipulation" type="textarea" v-model="ruleForm.cs_stipulation"></el-input>
            </div>
        </div>
        <div>
            <div class="sub_title marginT15">
                개인정보처리방침
            </div>
            <div class="sub_content_wrap">
                <el-input id="cs_privacy" type="textarea" v-model="ruleForm.cs_privacy"></el-input>
            </div>
        </div>
        <div>
            <div class="sub_title marginT15">
                개인정보 제공방침
            </div>
            <div class="sub_content_wrap">
                <el-input id="cs_privacy_provide" type="textarea"
                          v-model="ruleForm.cs_privacy_provide"></el-input>
            </div>
        </div>
        <div>
            <div class="sub_title marginT15">
                결제 서비스 이용 약관
            </div>
            <div class="sub_content_wrap">
                <el-input id="cs_payment" type="textarea" v-model="ruleForm.cs_payment"></el-input>
            </div>
        </div>
        <div>
            <div class="sub_title marginT15">
                회원탈퇴 약관
            </div>
            <div class="sub_content_wrap">
                <el-input id="cs_leave" type="textarea" v-model="ruleForm.cs_leave"></el-input>
            </div>
        </div>
        <div>
            <div class="sub_title marginT15">
                포인트 이용약관
            </div>
            <div class="sub_content_wrap">
                <el-input id="cs_point" type="textarea" v-model="ruleForm.cs_point"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import util from '@/mixins/util';
import summernote from "@/mixins/summernote";
import EventBus from "@/mixins/event-bus";

export default {
    name: "TermsComponent",
    mixins: [alertMixins, summernote],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            ruleForm: {
                cs_privacy_provide: '',
                cs_privacy: '',
                cs_stipulation: '',
                cs_leave: '',
                cs_point: '',
                cs_payment : '',
            },
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.initSummernote('cs_stipulation', '서비스 이용약관', 'ruleForm.cs_stipulation');
        this.initSummernote('cs_privacy', '개인정보처리방침', 'ruleForm.cs_privacy');
        this.initSummernote('cs_privacy_provide', '개인정보 제공방침', 'ruleForm.cs_privacy_provide');
        this.initSummernote('cs_payment', '결제서비스 이용약관', 'ruleForm.cs_payment');
        this.initSummernote('cs_leave', '개인정보 제공방침', 'ruleForm.cs_leave');
        this.initSummernote('cs_point', '포인트 이용약관', 'ruleForm.cs_point');
        this.getConfig();

        EventBus.$on('writeTerms', this.writeTerms);
    },
    beforeDestroy() {
        EventBus.$off('writeTerms');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getConfig() {
            try {
                this.$api.$terms.getConfigTerm().then(data => {
                    if (data.Data.Result.Info.Type === 1) {
                        let res = data.Data.Result.List[0];
                        this.afterFunc(res);
                    }
                })
            } catch(e) {
                console.log(e)
            }
        },

        afterFunc(res) {
            if (util.isEmpty(res)) {
                return false;
            }

            this.ruleForm.cs_privacy_provide = res.cs_privacy_provide;
            this.ruleForm.cs_stipulation = res.cs_stipulation;
            this.ruleForm.cs_privacy = res.cs_privacy;
            this.ruleForm.cs_payment = res.cs_payment;
            this.ruleForm.cs_leave = res.cs_leave;
            this.ruleForm.cs_point = res.cs_point;
            $('#cs_privacy_provide').summernote('code', util.htmlDecode(this.ruleForm.cs_privacy_provide));
            $('#cs_stipulation').summernote('code', util.htmlDecode(this.ruleForm.cs_stipulation));
            $('#cs_privacy').summernote('code', util.htmlDecode(this.ruleForm.cs_privacy));
            $('#cs_payment').summernote('code', util.htmlDecode(this.ruleForm.cs_payment));
            $('#cs_leave').summernote('code', util.htmlDecode(this.ruleForm.cs_leave));
            $('#cs_point').summernote('code', util.htmlDecode(this.ruleForm.cs_point));
        },

        writeTerms() {
            try {
                this.$api.$terms.updateConfigTerm(this.ruleForm).then(res => res.Data.Result).then(res => {
                    if (res.Info.status === true) {
                        this.oneBtnSaveAlert();
                    } else {
                        this.errorAlert(res.Info.reason);
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
